<template>
<ItpButton
  :text="text"
  :icon="icon"
  :variant="variant"
  :spinning="downloader.isRunning"
  :disabled="disabled"
  :size="size"
  :tooltip="tooltip"
  :block="block"
  :dropdownItem="dropdownItem"
  dropdown-stays-open-on-click
  class="artifact-job"
  v-if="loaded"
  @click.prevent.stop="evh_7315092382398562_clickPreventStop($event, {})"
>
</ItpButton>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ArtifactJob extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getDownloader(...args: any[]) {
    if (!this._downloader) {
      this._downloader = new this.$app.helpers.ArtifactDownloader(
        this.$app,
        this.handleError.bind(this)
      );
      console.log("downloader constructed")
    }
    return this._downloader
  }

  beforeDestroy(...args: any[]) {
    { { this.downloader && this.downloader.stop() } }
  }

  submit(...args: any[]) {
    const [event] = args;

    event.originalEvent.preventDefault();
    event.originalEvent.stopPropagation();

    if (this.downloader.isRunning) {
      return false;
    }

    this.downloader.begin(
      Promise
        .resolve(_.isFunction(this.payload) ? this.payload() : this.payload)
        .then(payload => {
          if (!payload || payload.cancel) {
            return;
          }
          return this.$app.connections
            .request(this.operation, { content: payload })
            .then(resp => resp.data)
        })
    )
  }

  @Prop({
    type: String,
  })
  icon!: string;

  @Watch('icon')
  onIcon(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("icon")
  }

  @Prop({
    required: true,
    type: String,
  })
  text!: string;

  @Watch('text')
  onText(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("text")
  }

  @Prop({
    required: true,
    type: String,
  })
  operation!: string;

  @Watch('operation')
  onOperation(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("operation")
  }

  @Prop({
    required: true,
  })
  payload!: Function;

  @Watch('payload')
  onPayload(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("payload")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  dropdownItem!: boolean;

  @Watch('dropdownItem')
  onDropdown_item(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("dropdownItem")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  block!: boolean;

  @Watch('block')
  onBlock(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("block")
  }

  @Prop({
    type: String,
  })
  variant!: string;

  @Watch('variant')
  onVariant(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("variant")
  }

  @Prop({
    type: Boolean,
  })
  disabled!: boolean;

  @Watch('disabled')
  onDisabled(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("disabled")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  @Prop({
    type: String,
  })
  tooltip!: string;

  @Watch('tooltip')
  onTooltip(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("tooltip")
  }

  @Prop({
    type: Number,
    default: 1000,
  })
  pollingInterval!: number;

  @Watch('pollingInterval')
  onPolling_interval(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("pollingInterval")
  }

  downloader!: any;

  async $$load_downloader() {
    return this.getDownloader()
  }

  ux!: any;
  dataMembers = ['downloader', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        downloader: null,
        ux: null,
      },
    }
  }

  async act_7315092382398562_script_4414_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_4414, alias=undefined
    this.submit($event)
  }

  async act_7315092382398562_script_4414_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_4414, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_4414_getActionArgs_value($event),
    }
  }

  async evh_7315092382398562_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_script_4414: actions.ScriptAction;
    evh_7315092382398562_clickPreventStop_4413: actions.EventHandlerImpl;
    evh_7315092382398562_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_script_4414 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_4414_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_clickPreventStop_4413 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_4414,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_7315092382398562_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_clickPreventStop_4413],
      }
    );
    return {
      act_7315092382398562_script_4414,
      evh_7315092382398562_clickPreventStop_4413,
      evh_7315092382398562_clickPreventStop,
    }
  }
}

Vue.component("ArtifactJob", ArtifactJob);

</script>